import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "../Layout/CookieBanner";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />

      <main className="flex-grow">
        {children}
      </main>

      <Footer />

      {/* Cookie Banner global & unabhängig vom Content */}
      <CookieBanner />
    </div>
  );
};

export default Layout;
